import { useState, useEffect } from 'react';
import { getForms, createFormEntry, updateFormEntry, deleteFormEntry } from '../utils/api';
import toast from 'react-hot-toast';

const CATEGORIES = [
  { key: 'sales_status',    label: 'Sales Status' },
  { key: 'prod_status',     label: 'Production Status' },
  { key: 'loan_providers',  label: 'Loan Providers' },
  { key: 'pay_methods',     label: 'Payment Methods' },
  { key: 'permit_status',   label: 'Permit Status' },
  { key: 'material_status', label: 'Material Status' },
  { key: 'service_types',   label: 'Service Types' },
];

export default function FormsList() {
  const [forms, setForms] = useState({});
  const [adding, setAdding] = useState({});
  const [editId, setEditId] = useState(null);
  const [editVal, setEditVal] = useState('');

  useEffect(() => { getForms().then(setForms); }, []);

  async function handleAdd(cat) {
    const val = (adding[cat] || '').trim();
    if (!val) return;
    try {
      const created = await createFormEntry({ category: cat, value: val });
      setForms(f => ({ ...f, [cat]: [...(f[cat] || []), created] }));
      setAdding(a => ({ ...a, [cat]: '' }));
      toast.success('Added');
    } catch { toast.error('Error adding'); }
  }

  async function handleEdit(id, cat) {
    if (!editVal.trim()) return;
    try {
      const updated = await updateFormEntry(id, { value: editVal });
      setForms(f => ({ ...f, [cat]: f[cat].map(x => x.id === id ? updated : x) }));
      setEditId(null);
      toast.success('Updated');
    } catch { toast.error('Error updating'); }
  }

  async function handleDelete(id, cat) {
    if (!window.confirm('Delete this value?')) return;
    await deleteFormEntry(id);
    setForms(f => ({ ...f, [cat]: f[cat].filter(x => x.id !== id) }));
    toast.success('Deleted');
  }

  return (
    <>
      <div className="page-header"><h2>Forms List</h2></div>
      <div className="page-body">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 20 }}>
          {CATEGORIES.map(({ key, label }) => (
            <div key={key} className="card">
              <div className="card-header"><h3>{label}</h3></div>
              <div style={{ padding: '8px 16px 14px' }}>
                {(forms[key] || []).map(item => (
                  <div key={item.id} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '6px 0', borderBottom: '1px solid var(--gray-100)' }}>
                    {editId === item.id ? (
                      <>
                        <input
                          className="form-input"
                          style={{ flex: 1, padding: '4px 8px', fontSize: '0.84rem' }}
                          value={editVal}
                          onChange={e => setEditVal(e.target.value)}
                          onKeyDown={e => e.key === 'Enter' && handleEdit(item.id, key)}
                          autoFocus
                        />
                        <button className="btn btn-primary btn-sm" onClick={() => handleEdit(item.id, key)}>Save</button>
                        <button className="btn btn-ghost btn-sm" onClick={() => setEditId(null)}>✕</button>
                      </>
                    ) : (
                      <>
                        <span style={{ flex: 1, fontSize: '0.875rem' }}>{item.value}</span>
                        <button className="btn btn-ghost btn-sm" onClick={() => { setEditId(item.id); setEditVal(item.value); }}>✎</button>
                        <button className="btn btn-ghost btn-sm" style={{ color: 'var(--red-500)' }} onClick={() => handleDelete(item.id, key)}>✕</button>
                      </>
                    )}
                  </div>
                ))}
                <div style={{ display: 'flex', gap: 8, marginTop: 10 }}>
                  <input
                    className="form-input"
                    style={{ flex: 1, padding: '5px 8px', fontSize: '0.84rem' }}
                    placeholder="Add new value…"
                    value={adding[key] || ''}
                    onChange={e => setAdding(a => ({ ...a, [key]: e.target.value }))}
                    onKeyDown={e => e.key === 'Enter' && handleAdd(key)}
                  />
                  <button className="btn btn-primary btn-sm" onClick={() => handleAdd(key)}>Add</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
